import { render, staticRenderFns } from "./LobbyPage.vue?vue&type=template&id=09b87504"
import script from "./LobbyPage.vue?vue&type=script&lang=js"
export * from "./LobbyPage.vue?vue&type=script&lang=js"
import style0 from "./LobbyPage.vue?vue&type=style&index=0&id=09b87504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports